module.exports = __webpack_public_path__ + "img/demoArticle.1642fffe.jpg";